// it converts react-router path like `/:tenantCode/something/:id/show` to `/utmost/something/1/show`
import { queryStringStringify } from './queryString';

export function toSearchParamsString<T extends Partial<Record<string, any>>>(params?: T): string {
  if (!params) {
    return '';
  }
  const result: Record<string, string | string[]> = {};
  Object.keys(params).forEach((key) => {
    if (params[key] !== null || params[key] !== undefined) {
      if (Array.isArray(params[key])) {
        result[key] = params[key].map((arr: any) => JSON.stringify(arr));
      } else if (typeof params[key] === 'object' && params[key] instanceof Date) {
        result[key] = new Date(params[key]).toISOString();
      } else if (typeof params[key] === 'object') {
        result[key] = JSON.stringify(params[key]);
      } else {
        result[key] = `${params[key]}`;
      }
    }
  });
  return queryStringStringify(result, { arrayFormat: 'bracket' });
}
